export const ListaRadnogVremenaResourcesEN: ListaRadnogVremenaResourcesInterface =
  {
    title: "Working Time List",
    errors: {
      query:
        "An error occurred while loading users. Please contact the administrator.",
    },
    inputFields: {
      endDate: {
        label: "End date",
      },
      startDate: {
        label: "Start date",
      },
      user: {
        error: "Please select user",
        label: "Select user",
        name: "user",
        placeholder: "Select user",
      },
    },
    pdf: {
      button: "Download PDF",
      document: {
        ukupnoVrijeme: "Total hours",
        name: "First and last name",
        title: "Working time evidence",
        odabraniPeriod: "Selected period",
        potpisFooter: "Signature",
        upisaoFooter: "Entered by",
        entryType: "Evidence type",
        napomena: "Note",
        pocetak: "Start",
        pocetakPauze: "Break start",
        potpisano: "Signature",
        zavrsetak: "End",
        zavrsetakPauze: "Break end",
        tipovi: {
          DEZURA: "On-call duty",
          ODSUSTVO: "Absence",
          PRIPRAVNOST: "Standby",
          RADNOVRIJEME: "Working time",
          RADUSMJENAMA: "Shift work",
          TERENSKIRAD: "Field work",
          BOLOVANJE: "Sick leave",
          SLOBODANDAN: "Day off",
        },
      },
    },
  };

interface InputFieldInterface {
  label: string;
  name: string;
  placeholder: string;
  error: string;
}

export interface RadnoVrijemePDFInterface {
  name: string;
  title: string;
  ukupnoVrijeme: string;
  odabraniPeriod: string;
  potpisFooter: string;
  upisaoFooter: string;
  entryType: string;
  pocetak: string;
  zavrsetak: string;
  pocetakPauze: string;
  zavrsetakPauze: string;
  napomena: string;
  potpisano: string;
  tipovi: {
    RADNOVRIJEME: string;
    RADUSMJENAMA: string;
    TERENSKIRAD: string;
    DEZURA: string;
    PRIPRAVNOST: string;
    ODSUSTVO: string;
    BOLOVANJE: string;
    SLOBODANDAN: string;
  };
}

export interface ListaRadnogVremenaResourcesInterface {
  title: string;
  errors: {
    query: string;
  };
  inputFields: {
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
    user: InputFieldInterface;
  };
  pdf: {
    button: string;
    document: RadnoVrijemePDFInterface;
  };
}
